/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { LegalTechSkill, LegalTechSkillCategory, LegalTechnicalSkillProficiency } from "../enums";
export const candidateLegalTechnicalSkillSchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  legalTechCategory: z.nativeEnum(LegalTechSkillCategory).nullish(),
  legalTechSkill: z.nativeEnum(LegalTechSkill).nullish(),
  proficiency: z.nativeEnum(LegalTechnicalSkillProficiency).nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidateLegalTechnicalSkill = z.infer<typeof candidateLegalTechnicalSkillSchema>;
